<template>
    <div class="space-y-6 bg-white rounded-md shadow-sm border border-gray-200 pb-6">
        <div class="h-72 overflow-y-scroll p-6 text-gray-700" @scroll="handleScroll">
            <terms-and-conditions-content :terms="terms" />
        </div>
    </div>
</template>

<script>
import TermsAndConditionsContent from './TermsAndConditionsContent.vue'

export default {
    name: 'TermsAndConditionsForm',
    components: {
        TermsAndConditionsContent,
    },
    props: {
        terms: {
            type: String,
            default: null,
        },
    },
    methods: {
        handleScroll(event) {
            const el = event.target;
            if ((el.offsetHeight + el.scrollTop) >= el.scrollHeight) {
                this.$emit('scrolled-to-bottom');
            }
        }
    }
}
</script>
